import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfigPdvDeliveryResponse } from 'src/app/shared/models/configuracao.model';
import { StorageService } from './storage.service';
import { EntregaPorBairroRequest } from 'src/app/shared/models/bairro.model';
import { EntregaGeral } from 'src/app/shared/enums/entrega.enum';
import { CastModelUtils } from 'src/app/shared/utils/CastModelUtils';
import { Computadores } from 'src/app/shared/models/computadores.model';

@Injectable({
    providedIn: 'root'
})
export class ConfigSistemaService {
    public config$ = new BehaviorSubject<ConfigPdvDeliveryResponse>(new ConfigPdvDeliveryResponse());
    public config = new ConfigPdvDeliveryResponse();

    constructor(
        private storageService: StorageService,
    ) {
        this.carregarPedido();
    }

    public async obterPedido(): Promise<ConfigPdvDeliveryResponse> {
        const pedidoSalvo = await this.storageService.get('configPedido');
        return pedidoSalvo === null ? new ConfigPdvDeliveryResponse() : pedidoSalvo;
    }

    private async carregarPedido() {
        const pedido = await this.obterPedido();
        this.alterarConfigSemSalvar(pedido);
    }

    public async salvarComputadores(computadores: Computadores[]) {
        this.config.computadores = computadores;
        this.alterarConfigSemSalvar(this.config);
        this.alterarConfig(this.config);
    }

    public async salvarConfig(config: ConfigPdvDeliveryResponse) {
        await this.storageService.set('configPedido', config);
    }

    public alterarConfigSemSalvar(config: ConfigPdvDeliveryResponse) {
        this.config$.next(config);
        this.config = config;
    }
    
    public async alterarConfig(config: ConfigPdvDeliveryResponse) {
        await this.salvarConfig(config);
        this.alterarConfigSemSalvar(config);
    }

    public alterarEntregaGeral(entregaGeral: EntregaPorBairroRequest) {
        const configModeficada = this.config;
        configModeficada.taxasEntrega.forEach((taxa) => {
            if (taxa.bairro === EntregaGeral.Bairro) {
                taxa = CastModelUtils.ClonarObjetoComPropriedadesIguais(entregaGeral, new ConfigPdvDeliveryResponse());
            }
        });

        this.alterarConfig(configModeficada);
    }
}
